import { useQuery } from '@tanstack/react-query';
import {
  memberEntitlementService,
  MemberEntitlementListResponse,
} from '@/services/memberEntitlement.service';
import { defaultQueryOptions } from '@/config/react-query.config';

export const memberEntitlementKeys = {
  all: ['member-entitlements'] as const,
  mine: () => [...memberEntitlementKeys.all, 'mine'] as const,
};

/**
 * Hook to fetch the authenticated member's own entitlement balances.
 *
 * Separate from any plan-shaped hook (`useMembership`/`useMembershipUsage`)
 * because balances change every time the member books — a separate endpoint
 * (`GET /member-entitlements/me`) with its own cache entry, mirroring
 * `useMembershipUsage`'s rationale.
 *
 * D-08/D-09: `ENTITLEMENT_CONSUME` is asynchronous, so this hook must NEVER be
 * used to read a balance immediately after a booking confirms. BOTH success
 * screens (v1 and v2) show an optimistic decrement from navigation state
 * instead of refetching this hook.
 */
export const useMemberEntitlements = () => {
  return useQuery<MemberEntitlementListResponse, Error>({
    queryKey: memberEntitlementKeys.mine(),
    queryFn: () => memberEntitlementService.getMyBalances(),
    ...defaultQueryOptions,
  });
};

export default useMemberEntitlements;
